/**
 * Wave 23 — Country SEO i18n
 * New countries: Latvia, Côte d'Ivoire, Bahrain
 * Translation gaps filled: ZH/JA/KO/SV/DA for Paraguay, Guatemala, Dominican Republic
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE23: CountrySEOMap = {

  latvia: {
    fr: {
      title: 'Centre d\'appel Lettonie | Service Client Multilingue | Call IT Dev',
      description: 'Centre d\'appel pour la Lettonie : agents multilingues, fuseau EET, CSAT 95%, dès 3 $/h. Hub FinTech balte.',
      heroTitle: 'Centre d\'appel pour la Lettonie — Support Multilingue',
      heroSubtitle: 'Service client premium pour le marché balte. Hub FinTech de Riga.',
    },
    de: {
      title: 'Callcenter Lettland | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Callcenter für Lettland: mehrsprachige Agenten, EET-Zeitzone, CSAT 95%, ab 3 $/h. Baltischer FinTech-Hub.',
      heroTitle: 'Callcenter für Lettland — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den baltischen Markt. Rigas FinTech-Hub.',
    },
    es: {
      title: 'Call Center Letonia | Atención Multilingüe | Call IT Dev',
      description: 'Call center para Letonia: agentes multilingües, zona EET, CSAT 95%, desde 3 $/h. Hub FinTech báltico.',
      heroTitle: 'Call Center para Letonia — Soporte Multilingüe',
      heroSubtitle: 'Servicio al cliente premium para el mercado báltico.',
    },
    ar: {
      title: 'مركز اتصال لاتفيا | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال للاتفيا: وكلاء متعددو اللغات، منطقة EET، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال للاتفيا — دعم متعدد اللغات',
      heroSubtitle: 'خدمة عملاء متميزة للسوق البلطيقي.',
    },
    zh: {
      title: '拉脱维亚呼叫中心 | 多语言客服 | Call IT Dev',
      description: '拉脱维亚呼叫中心：多语言座席，EET时区，CSAT 95%，3美元/小时起。波罗的海金融科技中心。',
      heroTitle: '拉脱维亚呼叫中心 — 多语言支持',
      heroSubtitle: '波罗的海市场优质客户服务。里加金融科技中心。',
    },
    ja: {
      title: 'ラトビアコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'ラトビア向けコールセンター：多言語対応、EET時間帯、CSAT 95%、3$/時間〜。バルトFinTechハブ。',
      heroTitle: 'ラトビア向けコールセンター — 多言語サポート',
      heroSubtitle: 'バルト市場向けプレミアムカスタマーサービス。',
    },
    ko: {
      title: '라트비아 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '라트비아 콜센터: 다국어 상담원, EET 시간대, CSAT 95%, 시간당 3달러부터. 발트 핀테크 허브.',
      heroTitle: '라트비아 콜센터 — 다국어 지원',
      heroSubtitle: '발트 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Lettland | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Lettland: flerspråkiga agenter, EET-tidszon, CSAT 95%, från 3 $/h. Baltisk FinTech-hub.',
      heroTitle: 'Callcenter för Lettland — Flerspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst för den baltiska marknaden.',
    },
    da: {
      title: 'Callcenter Letland | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Letland: flersprogede agenter, EET-tidszone, CSAT 95%, fra 3 $/t. Baltisk FinTech-hub.',
      heroTitle: 'Callcenter til Letland — Flersproget Support',
      heroSubtitle: 'Premium kundeservice til det baltiske marked.',
    },
  },

  'cote-divoire': {
    fr: {
      title: 'Centre d\'appel Côte d\'Ivoire | Service Client Francophone | Call IT Dev',
      description: 'Centre d\'appel pour la Côte d\'Ivoire : agents francophones natifs, fuseau GMT, CSAT 95%, dès 3 $/h. Capital tech d\'Afrique de l\'Ouest.',
      heroTitle: 'Centre d\'appel pour la Côte d\'Ivoire — Support Francophone',
      heroSubtitle: 'Service client premium francophone. Abidjan, capitale tech d\'Afrique de l\'Ouest.',
    },
    en: {
      title: 'Call Center Côte d\'Ivoire | Francophone Customer Service | Call IT Dev',
      description: 'Call center for Côte d\'Ivoire: native French-speaking agents, GMT timezone, CSAT 95%, from $3/hr. West Africa\'s tech capital.',
      heroTitle: 'Call Center for Côte d\'Ivoire — Francophone Support',
      heroSubtitle: 'Premium francophone customer service. Abidjan, West Africa\'s tech capital.',
    },
    de: {
      title: 'Callcenter Elfenbeinküste | Frankophoner Kundenservice | Call IT Dev',
      description: 'Callcenter für die Elfenbeinküste: frankophone Agenten, GMT-Zeitzone, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Callcenter für die Elfenbeinküste — Frankophoner Support',
      heroSubtitle: 'Premium frankophoner Kundenservice. Abidjan, Tech-Hauptstadt Westafrikas.',
    },
    ar: {
      title: 'مركز اتصال كوت ديفوار | خدمة عملاء فرنكوفونية | Call IT Dev',
      description: 'مركز اتصال لكوت ديفوار: وكلاء فرنكوفونيون، منطقة GMT، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لكوت ديفوار — دعم فرنكوفوني',
      heroSubtitle: 'خدمة عملاء فرنكوفونية متميزة. أبيدجان، عاصمة التكنولوجيا في غرب أفريقيا.',
    },
    zh: {
      title: '科特迪瓦呼叫中心 | 法语客服 | Call IT Dev',
      description: '科特迪瓦呼叫中心：法语母语座席，GMT时区，CSAT 95%，3美元/小时起。西非科技之都。',
      heroTitle: '科特迪瓦呼叫中心 — 法语支持',
      heroSubtitle: '优质法语客户服务。阿比让，西非科技之都。',
    },
    ja: {
      title: 'コートジボワールコールセンター | フランス語サポート | Call IT Dev',
      description: 'コートジボワール向けコールセンター：フランス語ネイティブ、GMT時間帯、CSAT 95%、3$/時間〜。',
      heroTitle: 'コートジボワール向けコールセンター — フランス語サポート',
      heroSubtitle: 'プレミアムフランス語カスタマーサービス。アビジャン、西アフリカのテック首都。',
    },
    ko: {
      title: '코트디부아르 콜센터 | 프랑스어 고객 서비스 | Call IT Dev',
      description: '코트디부아르 콜센터: 프랑스어 원어민, GMT 시간대, CSAT 95%, 시간당 3달러부터.',
      heroTitle: '코트디부아르 콜센터 — 프랑스어 지원',
      heroSubtitle: '프리미엄 프랑스어 고객 서비스. 아비장, 서아프리카 테크 수도.',
    },
    sv: {
      title: 'Callcenter Elfenbenskusten | Fransktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Elfenbenskusten: fransktalande agenter, GMT-tidszon, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Elfenbenskusten — Fransktalande Stöd',
      heroSubtitle: 'Premium fransktalande kundtjänst. Abidjan, Västafrikas tech-huvudstad.',
    },
    da: {
      title: 'Callcenter Elfenbenskysten | Fransktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Elfenbenskysten: fransktalende agenter, GMT-tidszone, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter til Elfenbenskysten — Fransktalende Support',
      heroSubtitle: 'Premium fransktalende kundeservice. Abidjan, Vestafrikas tech-hovedstad.',
    },
  },

  bahrain: {
    fr: {
      title: 'Centre d\'appel Bahreïn | Service Client Arabe & Anglais | Call IT Dev',
      description: 'Centre d\'appel pour Bahreïn : agents arabophones, fuseau AST, CSAT 95%, dès 3 $/h. Hub FinTech du Golfe.',
      heroTitle: 'Centre d\'appel pour Bahreïn — Support Arabe & Anglais',
      heroSubtitle: 'Service client premium pour le marché bahreïni. Sandbox FinTech du Golfe.',
    },
    de: {
      title: 'Callcenter Bahrain | Arabisch-Englischer Kundenservice | Call IT Dev',
      description: 'Callcenter für Bahrain: arabischsprachige Agenten, AST-Zeitzone, CSAT 95%, ab 3 $/h. FinTech-Hub am Golf.',
      heroTitle: 'Callcenter für Bahrain — Arabisch-Englischer Support',
      heroSubtitle: 'Premium-Kundenservice für Bahrain. FinTech-Sandbox am Golf.',
    },
    es: {
      title: 'Call Center Bahréin | Atención Árabe e Inglés | Call IT Dev',
      description: 'Call center para Bahréin: agentes arabófonos, zona AST, CSAT 95%, desde 3 $/h. Hub FinTech del Golfo.',
      heroTitle: 'Call Center para Bahréin — Soporte Árabe e Inglés',
      heroSubtitle: 'Servicio al cliente premium para Bahréin. Sandbox FinTech del Golfo.',
    },
    ar: {
      title: 'مركز اتصال البحرين | خدمة عملاء عربية وإنجليزية | Call IT Dev',
      description: 'مركز اتصال للبحرين: وكلاء ناطقون بالعربية، منطقة AST، CSAT 95%، من 3 $/ساعة. مركز FinTech الخليجي.',
      heroTitle: 'مركز اتصال للبحرين — دعم عربي وإنجليزي',
      heroSubtitle: 'خدمة عملاء متميزة للسوق البحريني. صندوق الرمل التنظيمي للتكنولوجيا المالية.',
    },
    zh: {
      title: '巴林呼叫中心 | 阿拉伯语英语客服 | Call IT Dev',
      description: '巴林呼叫中心：阿拉伯语座席，AST时区，CSAT 95%，3美元/小时起。海湾金融科技中心。',
      heroTitle: '巴林呼叫中心 — 阿拉伯语和英语支持',
      heroSubtitle: '巴林市场优质客户服务。海湾金融科技沙盒。',
    },
    ja: {
      title: 'バーレーンコールセンター | アラビア語・英語サポート | Call IT Dev',
      description: 'バーレーン向けコールセンター：アラビア語対応、AST時間帯、CSAT 95%、3$/時間〜。湾岸FinTechハブ。',
      heroTitle: 'バーレーン向けコールセンター — アラビア語・英語サポート',
      heroSubtitle: 'バーレーン市場向けプレミアムカスタマーサービス。',
    },
    ko: {
      title: '바레인 콜센터 | 아랍어 영어 고객 서비스 | Call IT Dev',
      description: '바레인 콜센터: 아랍어 상담원, AST 시간대, CSAT 95%, 시간당 3달러부터. 걸프 핀테크 허브.',
      heroTitle: '바레인 콜센터 — 아랍어 및 영어 지원',
      heroSubtitle: '바레인 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Bahrain | Arabisk & Engelsk Kundtjänst | Call IT Dev',
      description: 'Callcenter för Bahrain: arabisktalande agenter, AST-tidszon, CSAT 95%, från 3 $/h. Gulfens FinTech-hub.',
      heroTitle: 'Callcenter för Bahrain — Arabiskt & Engelskt Stöd',
      heroSubtitle: 'Premium kundtjänst för Bahrain. Gulfens FinTech-sandbox.',
    },
    da: {
      title: 'Callcenter Bahrain | Arabisk & Engelsk Kundeservice | Call IT Dev',
      description: 'Callcenter til Bahrain: arabisktalende agenter, AST-tidszone, CSAT 95%, fra 3 $/t. Golfens FinTech-hub.',
      heroTitle: 'Callcenter til Bahrain — Arabisk & Engelsk Support',
      heroSubtitle: 'Premium kundeservice til Bahrain. Golfens FinTech-sandbox.',
    },
  },

  // Fill ZH/JA/KO/SV/DA gaps for Paraguay
  paraguay: {
    zh: {
      title: '巴拉圭呼叫中心 | 西班牙语客服外包 | Call IT Dev',
      description: '巴拉圭呼叫中心外包：西班牙语座席，CSAT 95%，3美元/小时起。南美市场覆盖。',
      heroTitle: '巴拉圭呼叫中心 — 西班牙语支持',
      heroSubtitle: '以nearshore价格提供南美市场优质客户服务。',
    },
    ja: {
      title: 'パラグアイコールセンター | スペイン語カスタマーサポート | Call IT Dev',
      description: 'パラグアイ向けコールセンター：スペイン語対応、CSAT 95%、3$/時間〜。南米市場カバレッジ。',
      heroTitle: 'パラグアイ向けコールセンター — スペイン語サポート',
      heroSubtitle: 'ニアショア価格で南米市場向けプレミアムサービス。',
    },
    ko: {
      title: '파라과이 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '파라과이 콜센터: 스페인어 상담원, CSAT 95%, 시간당 3달러부터. 남미 시장 커버리지.',
      heroTitle: '파라과이 콜센터 — 스페인어 지원',
      heroSubtitle: '니어쇼어 가격으로 남미 시장 프리미엄 서비스.',
    },
    sv: {
      title: 'Callcenter Paraguay | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Paraguay: spansktalande agenter, CSAT 95%, från 3 $/h. Sydamerikansk marknadstäckning.',
      heroTitle: 'Callcenter för Paraguay — Spansktalande Stöd',
      heroSubtitle: 'Premium kundtjänst till nearshore-priser för Sydamerika.',
    },
    da: {
      title: 'Callcenter Paraguay | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter til Paraguay: spansktalende agenter, CSAT 95%, fra 3 $/t. Sydamerikansk markedsdækning.',
      heroTitle: 'Callcenter til Paraguay — Spansktalende Support',
      heroSubtitle: 'Premium kundeservice til nearshore-priser for Sydamerika.',
    },
  },

  // Fill ZH/JA/KO/SV/DA gaps for Guatemala
  guatemala: {
    zh: {
      title: '危地马拉呼叫中心 | 西班牙语英语双语客服 | Call IT Dev',
      description: '危地马拉呼叫中心：双语座席，CSAT 95%，3美元/小时起。中美洲BPO中心。',
      heroTitle: '危地马拉呼叫中心 — 双语支持',
      heroSubtitle: '中美洲市场优质客户服务。',
    },
    ja: {
      title: 'グアテマラコールセンター | 西英バイリンガルサポート | Call IT Dev',
      description: 'グアテマラ向けコールセンター：バイリンガル対応、CSAT 95%、3$/時間〜。中米BPOハブ。',
      heroTitle: 'グアテマラ向けコールセンター — バイリンガルサポート',
      heroSubtitle: '中米市場向けプレミアムカスタマーサービス。',
    },
    ko: {
      title: '과테말라 콜센터 | 스페인어 영어 이중 언어 | Call IT Dev',
      description: '과테말라 콜센터: 이중 언어 상담원, CSAT 95%, 시간당 3달러부터. 중미 BPO 허브.',
      heroTitle: '과테말라 콜센터 — 이중 언어 지원',
      heroSubtitle: '중미 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Guatemala | Tvåspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Guatemala: tvåspråkiga agenter, CSAT 95%, från 3 $/h. Centralamerikanskt BPO-nav.',
      heroTitle: 'Callcenter för Guatemala — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst för centralamerikanska marknaden.',
    },
    da: {
      title: 'Callcenter Guatemala | Tosproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Guatemala: tosprogede agenter, CSAT 95%, fra 3 $/t. Centralamerikansk BPO-hub.',
      heroTitle: 'Callcenter til Guatemala — Tosproget Support',
      heroSubtitle: 'Premium kundeservice til det centralamerikanske marked.',
    },
  },

  // Fill ZH/JA/KO/SV/DA gaps for Dominican Republic
  'dominican-republic': {
    zh: {
      title: '多米尼加共和国呼叫中心 | 双语客服外包 | Call IT Dev',
      description: '多米尼加共和国呼叫中心：西英双语座席，CSAT 95%，3美元/小时起。加勒比海BPO中心。',
      heroTitle: '多米尼加共和国呼叫中心 — 双语支持',
      heroSubtitle: '加勒比海市场优质客户服务。',
    },
    ja: {
      title: 'ドミニカ共和国コールセンター | バイリンガルサポート | Call IT Dev',
      description: 'ドミニカ共和国向けコールセンター：西英バイリンガル、CSAT 95%、3$/時間〜。カリブ海BPOハブ。',
      heroTitle: 'ドミニカ共和国向けコールセンター — バイリンガルサポート',
      heroSubtitle: 'カリブ海市場向けプレミアムサービス。',
    },
    ko: {
      title: '도미니카 공화국 콜센터 | 이중 언어 고객 서비스 | Call IT Dev',
      description: '도미니카 공화국 콜센터: 서영 이중 언어, CSAT 95%, 시간당 3달러부터. 카리브해 BPO 허브.',
      heroTitle: '도미니카 공화국 콜센터 — 이중 언어 지원',
      heroSubtitle: '카리브해 시장 프리미엄 고객 서비스.',
    },
    sv: {
      title: 'Callcenter Dominikanska Republiken | Tvåspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Dominikanska republiken: tvåspråkiga agenter, CSAT 95%, från 3 $/h. Karibisk BPO-hub.',
      heroTitle: 'Callcenter för Dominikanska Republiken — Tvåspråkigt Stöd',
      heroSubtitle: 'Premium kundtjänst för karibiska marknaden.',
    },
    da: {
      title: 'Callcenter Den Dominikanske Republik | Tosproget Kundeservice | Call IT Dev',
      description: 'Callcenter til Den Dominikanske Republik: tosprogede agenter, CSAT 95%, fra 3 $/t. Caribisk BPO-hub.',
      heroTitle: 'Callcenter til Den Dominikanske Republik — Tosproget Support',
      heroSubtitle: 'Premium kundeservice til det caribiske marked.',
    },
  },
};
